import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './shared/guard/auth.guard';
// import { GuestComponent } from './layouts/guest/guest.component';

const appRoutes: Routes = [
	{ 
    path: '', 
    component: AdminLayoutComponent, 
    data: { title: 'Main Views' }, 
    canActivate: [AuthGuard],
    children: [
      {
				path: '',
				redirectTo: '/home',
				pathMatch: 'full',
			},
      {
        path: 'home',
        component: HomeComponent,
      },
      {
				path: 'progress',
				loadChildren: () => import('./progress/progress.module').then((m) => m.ProgressModule),
			},
      {
				path: 'orders',
				loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
			},
      {
				path: 'reports',
				loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
			},
      {
				path: 'settings',
				loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
			},
      {
				path: 'admin',
				loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
			},
    ]
  },
  {
		path: 'login',
		loadChildren: () => import('./login/login.module').then(mod => mod.LoginModule)
	},
  { path: '**', redirectTo: '/', pathMatch: 'full' }
  // { path: '**', component: NotFoundComponent }
  // {
  //   path: '',
  //   component: AdminLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: '/default',
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: 'default',
  //       loadComponent: () => import('./demo/dashboard/default/default.component').then((c) => c.DefaultComponent)
  //     },
  //     {
  //       path: 'typography',
  //       loadComponent: () => import('./demo/elements/typography/typography.component').then((c) => c.TypographyComponent)
  //     },
  //     {
  //       path: 'color',
  //       loadComponent: () => import('./demo/elements/element-color/element-color.component').then((c) => c.ElementColorComponent)
  //     },
  //     {
  //       path: 'sample-page',
  //       loadComponent: () => import('./demo/other/sample-page/sample-page.component').then((c) => c.SamplePageComponent)
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   component: GuestComponent,
  //   children: [
  //     {
  //       path: 'login',
  //       loadComponent: () => import('./demo/pages/authentication/login/login.component').then((c) => c.LoginComponent)
  //     },
  //     {
  //       path: 'register',
  //       loadComponent: () => import('./demo/pages/authentication/register/register.component').then((c) => c.RegisterComponent)
  //     }
  //   ]
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
